import { createSlice } from "@reduxjs/toolkit";

interface FileManagerDialogState {
  isOpen: boolean;
}

const initialState: FileManagerDialogState = {
  isOpen: false,
};

export const fileManagerDialogSlice = createSlice({
  name: "fileManagerDialog",
  initialState,
  reducers: {
    openFileManagerDialog: (state) => {
      state.isOpen = true;
    },
    closeFileManagerDialog: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openFileManagerDialog, closeFileManagerDialog } =
  fileManagerDialogSlice.actions;

export default fileManagerDialogSlice.reducer;
